function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "layer1",
  transform: "translate(-18.447 50.716)"
}, React.createElement("path", {
  id: "path40",
  d: "M107.53 23.241h-42.7L43.482-13.737l21.35-36.979h42.699l21.35 36.979z",
  fill: "#f0f",
  fillOpacity: 1,
  strokeWidth: 1.012
}), React.createElement("path", {
  id: "path27",
  d: "M84.643 49.164L76.97 62.453H61.626l-7.672-13.289 7.672-13.289h15.345z",
  fill: "#ff9c00",
  fillOpacity: 1,
  strokeWidth: 1.546
}), React.createElement("path", {
  id: "path34",
  d: "M153.914 54.985L136.728 84.75h-34.37L85.171 54.985l17.185-29.766h34.371z",
  fill: "#157fff",
  fillOpacity: 1,
  strokeWidth: 0.997
}), React.createElement("path", {
  id: "path23",
  d: "M60.255 64.441L51.243 80.05H33.22L24.208 64.44l9.012-15.609h18.023z",
  fill: "#8a008a",
  fillOpacity: 1,
  strokeWidth: 0.524
}), React.createElement("path", {
  id: "path29",
  d: "M51.774 46.187H29.556L18.447 26.945l11.109-19.24h22.218l11.109 19.24z",
  fill: "#d3ff00",
  fillOpacity: 1,
  strokeWidth: 0.707
}), React.createElement("path", {
  id: "path36",
  d: "M123.588 19.061l-2.887 5h-5.774l-2.887-5 2.887-5h5.774z",
  fill: "#d48200",
  fillOpacity: 1,
  strokeWidth: 0.268
}), React.createElement("path", {
  id: "path38",
  d: "M90.981 40.034h-8.283l-4.142-7.174 4.142-7.174h8.283l4.142 7.174z",
  fill: "#efffa4",
  fillOpacity: 1,
  strokeWidth: 0.715
}), React.createElement("path", {
  id: "path43",
  d: "M44.2-8.194l4.15 7.187-4.15 7.186h-8.298l-4.149-7.186 4.15-7.187z",
  fill: "#003f8b",
  fillOpacity: 1,
  strokeWidth: 0.46
}), React.createElement("path", {
  id: "path26",
  d: "M144.924-6.329l8.552 14.812-8.552 14.811h-17.103L119.27 8.483 127.82-6.33z",
  fill: "#e6ff70",
  strokeWidth: 0.265
}), React.createElement("path", {
  id: "path28",
  d: "M81.755 74.562L75.68 85.083H63.531l-6.075-10.521 6.075-10.522h12.15z",
  fill: "#a9cd00",
  strokeWidth: 0.406
}), React.createElement("path", {
  d: "M73.646 34.524h-5.588l-2.794-4.84 2.794-4.838h5.588l2.793 4.839z",
  id: "path41",
  fill: "#abd1ff",
  fillOpacity: 1,
  strokeWidth: 0.482
}), React.createElement("path", {
  d: "M152.855-19.18L146.61-8.36h-12.494l-6.247-10.82 6.247-10.819h12.494z",
  id: "path44",
  fill: "#0057c0",
  fillOpacity: 1,
  strokeWidth: 1.259
}), React.createElement("path", {
  id: "path46",
  d: "M86.24 69.214h-5.305l-2.652-4.595 2.652-4.594h5.306l2.652 4.594z",
  fill: "#ff70ff",
  fillOpacity: 1,
  strokeWidth: 0.458
}), React.createElement("path", {
  d: "M38.962-32.983l6.704 11.61L38.962-9.76H25.554l-6.703-11.611 6.703-11.611z",
  id: "path48",
  fill: "#ffc870",
  fillOpacity: 1,
  strokeWidth: 0.743
}));

var SvgHex = function SvgHex(props) {
  return React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.467 135.467",
    id: "svg8"
  }, props), _ref);
};

export default SvgHex;